import Trans from 'next-translate/Trans';
import { usePersistStore } from 'store/usePersistStore';

export const EmailAlreadyRegistered: FC = () => {
    const { updateContactInformationState } = usePersistStore((s) => s);

    return (
        <div className="mt-3 flex w-full items-center space-x-2 bg-blueLighter p-4 lg:w-[410px]">
            <div className="flex h-[18px] w-[18px] min-w-[18px] items-center justify-center rounded-full bg-blueLight text-small text-white">
                ?
            </div>
            <span className="text-small">
                <Trans
                    i18nKey="This email is already registered. <0>You can login.</0>"
                    components={{
                        0: (
                            <button
                                className="font-bold underline"
                                tabIndex={0}
                                type="button"
                                onClick={() =>
                                    updateContactInformationState({
                                        isLoginPopupOpen: true,
                                    })
                                }
                            />
                        ),
                    }}
                />
            </span>
        </div>
    );
};
